/*
 * @Author: lwk liwkcool@163.com
 * @Date: 2025-05-15 10:09:31
 * @LastEditors: lwk liwkcool@163.com
 * @LastEditTime: 2025-05-19 12:21:59
 * @FilePath: \reception\src\api\prod.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// 分类
export const getCategorize = '/works/worksUpload/getCategorize';

// 标签
export const getPicture = '/works/worksUpload/getPicture';

// 作品
export const pordAdd = '/works/worksUpload/add';

// 作品列表
export const pordList = '/works/worksUpload/myListAll';

// 作品详情
export const pordDetail = (id) => `/works/worksUpload/${id}`;

// 作品修改
export const pordUpdate =  `/works/worksUpload/updateStatus`;

// 作品删除
export const updateWorks = `/works/worksUpload/updateWorks`;

// 作品数
export const getWorksCount = '/works/worksUpload/getStatusCounts';






